<template>
<div class="page">
  <div class="page-content">
    <div class="row justify-content-center align-content-center align-items-center calendario-no-disponible">
      <i class="f7-icons text-color-gray">exclamationmark_triangle</i>
      <span class="titulo">El calendario no está disponible ahora mismo</span>
      <span class="detalle">
        No se han podido comprobar tus permisos, así que el calendario no se abre: abrirlo con los
        de la sesión anterior podría enseñar o dejar modificar lo que ahora no te corresponde.
      </span>
      <span class="motivo" v-if="motivo">{{motivo}}</span>
      <a class="button button-fill button-large" @click="reintentar">Reintentar</a>
    </div>
  </div>
</div>
</template>
<script>
/**
 * #49 · Lo que se enseña cuando la barrera de la ruta del calendario no consigue resolver la
 * entrada (ver `barreraBloqueoVacaciones.js`).
 *
 * [#174, 03/10/2026] Se ha quedado con UN solo motivo: no saber quién está usando la aplicación
 * —`UsuarioActualizado.esperar()` o `RoutesUtils.tieneAcceso()` que fallan o expiran—. Antes
 * cubría también el fallo del interruptor `rh.vacaciones.bloqueo-generico`, y ese caso ya no llega
 * aquí: el calendario se monta con el valor más restrictivo y un aviso en la cabecera, porque
 * perder la pantalla entera por un dato que gobierna un caso era desproporcionado.
 *
 * Lo que sí sigue valiendo: no saber quién mira no es un dato que falte. Montar el calendario con
 * los permisos de la sesión anterior es lo que la #49 vino a eliminar, así que aquí el calendario
 * simplemente no se abre y quien lo pedía reintenta.
 */
export default {
  props: {
    /** URL del calendario que se intentaba abrir, para volver a intentarlo tal cual. */
    urlCalendario: { type: String, default: '/calendario/' },
    /** Qué falló, dicho en una línea. Informativo: la acción siempre es la misma, reintentar. */
    motivo: { type: String, default: '' }
  },
  methods: {
    reintentar() {
      const router = this.$f7router
        || (this.$f7 && this.$f7.views && this.$f7.views.main && this.$f7.views.main.router);
      if (!router) return;
      // `reloadCurrent` para sustituir ESTA pantalla y no dejar el error en el historial, e
      // `ignoreCache` para que la ruta se resuelva otra vez —que es lo que vuelve a comprobar el
      // acceso—.
      router.navigate(this.urlCalendario, { reloadCurrent: true, ignoreCache: true });
    }
  }
}
</script>
<style scoped>
.calendario-no-disponible { min-height: 100%; flex-direction: column; text-align: center; padding: 24px; }
.calendario-no-disponible .f7-icons { font-size: 64px; }
.calendario-no-disponible .titulo { font-size: 1.2rem; font-weight: 600; margin-top: 12px; }
.calendario-no-disponible .detalle { max-width: 520px; margin-top: 8px; color: #6b7885; }
.calendario-no-disponible .motivo { margin-top: 8px; color: #6b7885; font-size: 0.85rem; font-style: italic; }
.calendario-no-disponible .button { margin-top: 20px; width: 180px; }
</style>
